<template>
  <div>
    <p class="mb-2 mt-2">Imported fields : (click on the buttons below to copy field)</p>
    <div class="fields-container">
      <div class="relative" v-for="(field, index) in fields" :key="index">
        <button class="rounded bg-gray-200 button-field" v-on:click="(e) => {copyFieldToClipBoard(e, field)}">
          {{field}}
        </button>
        <div class="copy-popin">Copied !</div>
      </div>
    </div>
  </div>
</template>


<script>
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'ImportFields',
    props: {
      fields: {
        type: Array,
        required: true
      },
    },
    data () {
      return {

      }
    },
    computed: {
      ...mapGetters('account', {
        defaultLang: 'defaultLang',
        site: 'currentSite'
      }),
      languages () {
        return this.site.languages.map(lang => lang.lang)
      }
    },
    methods: {
      copyFieldToClipBoard(e, field) {
        navigator.clipboard.writeText("[[" + field + "]]")
        e.target.classList.add("active");
        setTimeout(() => {
          e.target.classList.remove("active")
        }, 1000)
      },
    },
    mounted () {

    }
  }

</script>

<style scoped>
.fields-container{
  display: flex;
  gap: 10px 16px;
  flex-flow: row wrap;
}

.button-field {
  padding: 4px 8px;
}

.copy-popin {
  display: none;
  z-index: 10;
  position: absolute;
  top: -36px;
  left: 50%;
  width: 70px;
  box-sizing: border-box;
  margin-left: -35px;
  padding: 4px 8px;
  text-align: center;
  border-radius: 0.25rem;
  background-color: #f59e0b;
  color: #fff;
}

.button-field.active ~ .copy-popin {
  display: block;
  animation: 1s linear pop;
  transform: scale(0);
}

@keyframes pop {
  from { transform: scale(0.5); }
  10%   { transform: scale(1); }
  90%   { transform: scale(1); }
  to { transform: scale(0.5); }
}

</style>



// WEBPACK FOOTER //
// src/components/common/import-fields.vue